import PropTypes from "prop-types";
import React from "react";
import "./NotFound.css";

const NotFound = ({ location }) => (
  <div className="NotFound">
    Oops, <code>{location.pathname}</code> doesn&#39;t exist
  </div>
);

NotFound.propTypes = {
  location: PropTypes.string.isRequired,
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/NotFound/NotFound.js